import { forwardRef, Inject, Injectable } from '@angular/core';
import { HttpAuthService } from './http-auth.service';
import { Observable } from 'rxjs/Observable';
import { Utilities } from '../utilities/utilities.model';
import { RequestMethod, Response, ResponseContentType } from '@angular/http';
import { AttachedFile } from '../models/attached-file.model';
import { AppConfigEnvironmentService } from '@shared/service/appconfig-environment.service';
import { AppConfigEnvironment } from '@shared/models/appconfig-environment.model';
import { UserV3Service } from '@shared/service/user-v-3.service';
import { SelectCommoditiesService } from '@shared/service/select-commodities.service';
import { logger } from '../utilities/logger.model';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { TranslateContext, TranslatePipe } from '../pipes/translate.pipe';

@Injectable()
export class UploadFileService {

    static ORDER_RESOURCE_TYPE = 'orders';
    static ALERT_RESOURCE_TYPE = 'alerts';
    static CLAIMS_RESOURCE_TYPE = 'claims';
    static AUTHORITY_RESOURCE_TYPE = 'authority';
    static TYRE_DDT_RESOURCE_TYPE = 'tyre';
    static CONTRACT_CLOSING_RESOURCE_TYPE = 'contract-closing';
	static CHANGE_USER_RESOURCE_TYPE = 'change-user';
	static BOOKINGS_RESOURCE_TYPE: string = 'bookings';
    environment: AppConfigEnvironment;

    constructor(@Inject(forwardRef(() => HttpAuthService)) private httpAuthService: HttpAuthService,
        private appConfig: AppConfigEnvironmentService,
        public userV3Service: UserV3Service,
        public selectCommoditiesService: SelectCommoditiesService,
        private snackBar: MatSnackBar,
        private translatePipe: TranslatePipe,
    ) {
        this.environment = appConfig.Environment;
    }

    uploadFile(file: AttachedFile): Observable<Response> {
        const url: string = this.environment.UPLOAD_API + '/file/upload';

        const body = {
            file_name: file.file_name,
            resource_type: file.resource_type,
            resource_id: file.resource_id,
            blob_type: file.blob_type,
            file_content: file.file_content,
            description: file.description
        };

        const options = Utilities.setRequestOptionAUTH();
        options.method = RequestMethod.Put;
        options.headers.set('Content-Type', 'application/json');
        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);
        return this.httpAuthService.put(url, body, this.environment.ROOT_REDIRECT, options);
    }

    updateFile(file: AttachedFile): Observable<Response> {
        const url: string = this.environment.UPLOAD_API + '/blob/' + file.uuid + '/description';

        const body = {
            description: file.description
        };
        const options = Utilities.setRequestOptionAUTH();
        options.method = RequestMethod.Post;
        options.headers.set('Content-Type', 'application/json');
        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);
        return this.httpAuthService.post(url, body, this.environment.ROOT_REDIRECT, options);
    }

    deleteFile(fileUUID: string): Observable<Response> {
        const url: string = this.environment.UPLOAD_API + '/blob/' + fileUUID + '/delete';

        const options = Utilities.setRequestOptionAUTH();
        options.method = RequestMethod.Delete;
        options.headers.set('Content-Type', 'application/json');
        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);


        return this.httpAuthService.delete(url, this.environment.ROOT_REDIRECT, options);
    }

    pollingFile(certificateUUID: string): Observable<any> {
        const url: string = this.environment.UPLOAD_API + '/blob/' + certificateUUID;

        const options = Utilities.setRequestOptionAUTH();
        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);

        return new Observable<any>((observer) => {
            this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options).subscribe(
                resp => {
                    if (!Utilities.isVoid(resp) && resp.status === 200) {
                        observer.next(resp.json());
                    } else {
                        observer.next(null);
                    }
                }, error => {
                    observer.error(error);
                }
            );
        });
    }

    downloadThumbnail(fileUUid: string, thumbnailSize?: any): Observable<Response> {
        let url: string = this.environment.UPLOAD_API + '/thumbnail/' + fileUUid;
        if (!Utilities.isVoid(thumbnailSize)) {
            url = url + '?width=' + thumbnailSize.width + '&height=' + thumbnailSize.height;
        }
        const options = Utilities.setRequestOptionAUTH();
        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);
        return new Observable<Response>(
            observer => {
                this.httpAuthService.put(url, null, this.environment.ROOT_REDIRECT, options).subscribe(res => {
                    if (res.status === 200) {
                        const thumbnailID = res.json().id;
                        this.downloadAttachedFile(thumbnailID).subscribe(resp => {
                            if (!Utilities.isVoid(resp)) {
                                observer.next(resp);
                            } else {
                                observer.error(null);
                            }
                        })
                    } else {
                        observer.error(res);
                    }
                }
                )
            }
        );
    }


    downloadAttachedFile(fileUUID: string): Observable<Response> {
        return new Observable<Response>(
            observer => {
                this.getToken(fileUUID).subscribe(
                    resp => {
                        if (!Utilities.isVoid(resp) && resp.status === 200) {
                            const token = resp.json().access_token;
                            this.downloadFile(token).subscribe(
                                response => {
                                    if (!Utilities.isVoid(response) && response.status === 200) {
                                        observer.next(response)
                                    } else {
                                        observer.error(response);
                                    }
                                }, error => {
                                    observer.error(error);
                                });
                        } else {
                            observer.error(resp);
                        }
                    }, error => {
                        observer.error(error);
                    });
            });
    }

    
    /**
     * Mostra messaggio di errore durante il download del file
     * 
     * PS: spostare in un file di utility
     * 
     */
    showDownloadFileErrorMessage(): void {
        const config: MatSnackBarConfig = new MatSnackBarConfig();
        config.duration = 2000;
        config.panelClass = ['snack-bar-error'];
        this.snackBar.open(this.translatePipe.transform('IMPOSSIBILE_SCARICARE_L_ALLEGATO', TranslateContext.SHARED), '', config);
    }
    
	/**
	 * Scarica il file e gestisce automaticamente l'errore
     * 
	 * 
	 * @param {AttachedFile} file
	 */ 
    downloadFileSimple(file: AttachedFile) : void {

        this.downloadAttachedFile(file.uuid).subscribe(
            response => {				

                if (Utilities.isEmpty(response)) {
                    logger.error('DownloadListComponent ', 'downloadFile ', response);
                    this.showDownloadFileErrorMessage();
                    return;
                }
                
                // TODO
                // capire se il download del File va gestito internamente dentro a questo servizio
                // o raggrupparlo in una utility esterna
                Utilities.downloadFile(response, file.getFileName());
                
            }, () => {
                this.showDownloadFileErrorMessage();
            }
        );	

        return;
    }
    

    downloadAttachedLpFile(praticeId: string, fileSelected: {file_manager_name: string, file_manager_id: string}): Observable<Response> {
        const url: string = this.environment.CLAIMS_API + '/claims/' + praticeId + '/lp/attachment';
        let options = Utilities.setRequestOptionAUTH();
        options.responseType = ResponseContentType.Blob;
        options.headers.set('apikey', this.environment.ALD_SUBSCRIPTION_KEY);
        return this.httpAuthService.post(url, fileSelected, this.environment.ROOT_REDIRECT, options);
    }

    downloadAttachedZip(fileUUID: string[], filename?: string): Observable<Response> {
        return new Observable<Response>(
            observer => {
                this.getTokenList(fileUUID).subscribe(
                    resp => {
                        if (!Utilities.isVoid(resp) && resp.status === 200) {
                            const token = resp.json() instanceof Array ? resp.json().map(item => item.access_token) : resp.json().access_token;
                            this.downloadFileZip(token, filename).subscribe(
                                response => {
                                    if (!Utilities.isVoid(response) && response.status === 200) {
                                        observer.next(response)
                                    } else {
                                        observer.error(response);
                                    }
                                }, error => {
                                    observer.error(error);
                                });
                        } else {
                            observer.error(resp);
                        }
                    }, error => {
                        observer.error(error);
                    });
            });
    }

    getTokenList(uuidList: string[]): Observable<Response> {
        const url: string = this.environment.UPLOAD_API + '/token/' + uuidList;
        const options = Utilities.setRequestOptionAUTH();
        options.headers.set('Content-Type', 'application/json');
        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);

        return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
    }

    getToken(uuid: string): Observable<Response> {
        const url: string = this.environment.UPLOAD_API + '/token/' + uuid;
        const options = Utilities.setRequestOptionAUTH();
        options.headers.set('Content-Type', 'application/json');
        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);

        return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
    }

    downloadFile(token: string): Observable<Response> {
        const url: string = this.environment.UPLOAD_API + '/blob/' + token + '/download';

        const options = Utilities.setRequestOptionAUTH();
        options.responseType = ResponseContentType.Blob;

        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);

        return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
    }

    downloadFileLp(documentId: string, filename: string): Observable<Response> {
        const url: string = this.environment.SERVER_ALDNEMOITA + '/mobilitygeut/ucm/claimdocument?dID=' + documentId + '&filename='+ filename;
        //Capire se le options vanno bene cosi
        let options = Utilities.setRequestOptionAUTH();
        options.responseType = ResponseContentType.Blob;
        options.headers.append("x-ALD-subscription-key", this.environment.ALD_SUBSCRIPTION_KEY)
        //options.headers.set('apikey', this.environment.UPLOAD_APIKEY);

        return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
    }

    downloadLpFileZip(praticeId: string, fileSelected: {file_manager_name: string, file_manager_id: string}[]): Observable<Response> {
        const url: string = this.environment.CLAIMS_API + '/claims/' + praticeId + '/lp/zip';
        let options = Utilities.setRequestOptionAUTH();
        options.responseType = ResponseContentType.Blob;
        options.headers.set('apikey', this.environment.ALD_SUBSCRIPTION_KEY);
        return this.httpAuthService.post(url, fileSelected, this.environment.ROOT_REDIRECT, options);
    }

    downloadFileZip(tokenList: string[], filename?: string): Observable<Response> {
        const url: string = this.environment.UPLOAD_API + '/blob/' + tokenList + '/download/zip';
        if (filename) {
            url.concat('?filename=' + filename);
        }
        const options = Utilities.setRequestOptionAUTH();
        options.responseType = ResponseContentType.Blob;
        options.headers.set('apikey', this.environment.UPLOAD_APIKEY);
        return this.httpAuthService.get(url, this.environment.ROOT_REDIRECT, options);
    }
    uploadDDT(transfer_id, attachment: AttachedFile): Observable<any> {
        let url = this.environment.NEMO_TYRES + `/transfers/${transfer_id}/attachments`;
        const nemo_commodity = this.selectCommoditiesService.getTyreCommodities();
        let options = Utilities.setNemoTyreRequestOptions(nemo_commodity);
        return Observable.create(observer => {
            this.httpAuthService.post(url, attachment, this.environment.ROOT_REDIRECT, options).subscribe(resp => {
                if (resp.status == 200) {
                    observer.next(resp.json());
                } else {
                    observer.error(null);
                }
            }, error => {
                observer.error(error);
            })
        })
    }

    uploadTyreImage(transfer_id, tyre_id: string, attachment: AttachedFile): Observable<any> {
        let url = this.environment.NEMO_TYRES + `/transfers/${transfer_id}/tyres/${tyre_id}/attachments`;
        const user_id = this.userV3Service.getCurrentUser().id;
        const nemo_commodity = this.selectCommoditiesService.getTyreCommodities();
        let options = Utilities.setNemoTyreRequestOptions(nemo_commodity);
        return Observable.create(observer => {
            this.httpAuthService.post(url, attachment, this.environment.ROOT_REDIRECT, options).subscribe(resp => {
                if (resp.status == 200) {
                    observer.next(resp.json());
                } else {
                    observer.error(null);
                }
            }, error => {
                observer.error(error);
            })
        })
    }

}
